import type { ChipProps } from '@mui/material'

type StatusChip = {
  label: string
  color: ChipProps['color']
  sx?: ChipProps['sx']
}

export const getStatusProps = (status: string): StatusChip => {
  switch (status) {
    case 'Complete':
      return {
        label: 'Connected',
        color: 'success',
        sx: {
          bgcolor: 'rgba(208, 241, 238, 1)',
          color: '#042522',
          fontWeight: 600,
        },
      }
    case 'Declined':
      return {
        label: 'Not Connected',
        color: 'error',
        sx: {
          bgcolor: 'rgba(254, 209, 208, 1)',
          color: '#640a08',
          fontWeight: 600,
        },
      }
    case 'Cancelled':
      return {
        label: 'Cancelled',
        color: 'warning',
        sx: {
          bgcolor: 'rgba(254, 232, 208, 1)',
          color: '#a16207',
          fontWeight: 600,
        },
      }
    case 'Active':
      return {
        label: 'Awaiting Connection',
        color: 'warning',
        sx: {
          bgcolor: 'rgba(254, 232, 208, 1)',
          color: '#a16207',
          fontWeight: 600,
        },
      }
    default:
      return {
        label: status || 'Unknown',
        color: 'default',
        sx: { fontWeight: 600 },
      }
  }
}
